<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="agpm.form.editTitle" description="agpm.form.editDescription"> </sm-page-header>

  <div class="flex flex-row gap-5">
    <div class="content w-3/4">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </div>
    <div class="flex flex-col gap-5 w-1/4">
      <sm-status [status]=" `agpm.status.${status}`" [extra]="agpmDetails?.agpm?.etapeProcess || ''"></sm-status>
      <div class="content h-fit flex flex-col gap-4" *ngFor="let blocks of controlBlocks">
        <sm-block-builder [blocks]="blocks"></sm-block-builder>
        <p class="text-xs text-red-500" *ngIf="commentError | async">{{ commentError | async }}</p>
      </div>
    </div>
  </div>
</div>
<sm-dialog #dialog [dialog]="agpmDialogObject"></sm-dialog>
